import campaign from "@/http/requests/campaign-banner"

export default {
  fetch({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      campaign.fetch(queryData).then(response => {
        commit('SET_CAMPAIGN_BANNERS', response.data.data.campaignBanners)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      campaign.add(data).then(response => {
        commit('ADD_CAMPAIGN_BANNER', response.data.data.createCampaignBanner)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      campaign.update(data).then(response => {
        commit('UPDATE_CAMPAIGN_BANNER', response.data.data.updateCampaignBanner)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, campaignId) {
    return new Promise((resolve, reject) => {
      campaign.delete(campaignId).then(response => {
        commit('DELETE_CAMPAIGN_BANNER', campaignId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, campaignId) {
    return new Promise((resolve, reject) => {
      campaign.infos(campaignId).then(response => {
        commit('ADD_CAMPAIGN_BANNER_INFOS', response.data.data.campaignBannerInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  setChosenBanner({ commit }, { event, userId }) {
    commit('SET_CHOSEN_BANNER', { event, userId })
  },
  listenToSocket({ commit, state }, userId) {
    if (state.socketListened === false) {
      window.Echo.private('choose.banner.position').
        listen('ChooseBannerPosition', (event) => {
          commit('SET_CHOSEN_BANNER', { event, userId })
        })
    }

    commit('SET_SOCKET_LISTENED')
  },
  resetChosenBanner({ commit }) {
    commit('RESET_CHOSEN_BANNER')
  },
  lastNews({ commit }) {
    return new Promise((resolve, reject) => {
      campaign.lastNews().then(response => {
        commit('SET_LAST_NEWS', response.data.data.news.items)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
